import { IApplicationState } from '../../../../../../types/types';
import { getAuthUser } from '../../../../../../store/model/authUser/selectors/getAuthUser';

export const authUserFullNameSelector = (state: IApplicationState): string => {
    return getAuthUser(state).fullName;
};
